import React, { Component } from 'react';
import ActionButton from '../../common/ActionButton';
import { TPageNotification, TSeries } from '../../../types';
import { ModalCancelWorker } from './CancelWorker';
import { ModalEditRates } from './EditRates';
import { ModalCancelSeries } from './CancelSeries';
import { ModalSeriesQualifyingQuestions } from '../../postjob/rolecard/agentview/QualifyingQuestions';
import { ModalSeriesConsultantSplits } from '../../postjob/rolecard/agentview/ConsultantSplits';
import { ModalChangeMatchingMode } from './ChangeMatchingMode';
import { matchingModeCodes } from '../../../consts';


type TSeriesTableSubComponentProps = {
    series: TSeries;
    onBookWorkers: (series: TSeries) => void;
    isModalCancelWorkerOpen: boolean;
    isModalCancelSeriesOpen: boolean;
    isModalEditRatesOpen: boolean;
    isModalSeriesQualifyingQuestionsOpen: boolean;
    isModalSeriesConsultantSplitsOpen: boolean;
    isModalChangeMatchingModeOpen: boolean;
    handleOpenModal: (modalName: string) => void;
    handleCloseModal: (modalName: string) => void;
    notification: TPageNotification;
    reloadData: () => void;
};

export default class SeriesTableSubComponent extends Component<TSeriesTableSubComponentProps> {

    render() {
        const {
            series,
            onBookWorkers,
            isModalCancelWorkerOpen,
            isModalCancelSeriesOpen,
            isModalEditRatesOpen,
            isModalSeriesQualifyingQuestionsOpen,
            isModalSeriesConsultantSplitsOpen,
            isModalChangeMatchingModeOpen,
            handleOpenModal,
            handleCloseModal,
            notification,
            reloadData,
        } = this.props;

        return (
            <div className="expanded-content">
                <ActionButton
                    text="Book workers"
                    onAction={() => onBookWorkers(series)}
                    requiredPermission="auth.manage_prejob_ops"
                />
                <ActionButton
                    text="Cancel worker"
                    onAction={() => handleOpenModal('CancelWorker')}
                    requiredPermission="auth.manage_prejob_ops"
                />
                <ActionButton
                    text="Cancel job"
                    onAction={() => handleOpenModal('CancelSeries')}
                    requiredPermission="auth.manage_prejob_ops"
                />
                <ActionButton
                    text="Change matching"
                    onAction={() => handleOpenModal('ChangeMatchingMode')}
                    requiredPermission="auth.manage_prejob_ops"
                />
                <ActionButton
                    text="Adjust rates"
                    onAction={() => handleOpenModal('EditRates')}
                    requiredPermission="auth.manage_prejob_ops"
                />
                {series.matching_mode !== matchingModeCodes.MANUAL && (
                    <ActionButton
                        text="Update questions"
                        onAction={() => handleOpenModal('SeriesQualifyingQuestions')}
                        requiredPermission="auth.manage_prejob_ops"
                    />
                )}
                <ActionButton
                    text="Update consultants"
                    onAction={() => handleOpenModal('SeriesConsultantSplits')}
                    requiredPermission="auth.manage_prejob_ops"
                />

                {isModalCancelWorkerOpen && (
                    <ModalCancelWorker
                        notification={notification}
                        reloadData={reloadData}
                        handleClose={handleCloseModal}
                        isOpen={isModalCancelWorkerOpen}
                        seriesId={series.id}
                    />
                )}
                {isModalCancelSeriesOpen && (
                    <ModalCancelSeries
                        notification={notification}
                        reloadData={reloadData}
                        handleClose={handleCloseModal}
                        isOpen={isModalCancelSeriesOpen}
                        seriesId={series.id}
                    />
                )}
                {isModalEditRatesOpen && (
                    <ModalEditRates
                        notification={notification}
                        reloadData={reloadData}
                        handleClose={handleCloseModal}
                        isOpen={isModalEditRatesOpen}
                        series={series}
                    />
                )}
                {isModalSeriesQualifyingQuestionsOpen && (
                    <ModalSeriesQualifyingQuestions
                        notification={notification}
                        reloadData={reloadData}
                        handleClose={handleCloseModal}
                        isOpen={isModalSeriesQualifyingQuestionsOpen}
                        seriesId={series.id}
                    />
                )}
                {isModalSeriesConsultantSplitsOpen && (
                    <ModalSeriesConsultantSplits
                        notification={notification}
                        reloadData={reloadData}
                        handleClose={handleCloseModal}
                        isOpen={isModalSeriesConsultantSplitsOpen}
                        series={series}
                    />
                )}
                {isModalChangeMatchingModeOpen && (
                    <ModalChangeMatchingMode
                        notification={notification}
                        reloadData={reloadData}
                        handleClose={handleCloseModal}
                        isOpen={isModalChangeMatchingModeOpen}
                        series={series}
                    />
                )}
            </div>
        );
    }
}
